import { render, staticRenderFns } from "./baseList.vue?vue&type=template&id=98df36ba&scoped=true&"
import script from "./baseList.vue?vue&type=script&lang=js&"
export * from "./baseList.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./baseList.vue?vue&type=style&index=0&id=98df36ba&scoped=true&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "98df36ba",
  "e316c99c"
  
)

export default component.exports